import React from 'react';
import { Label } from '../../components/ui/label';
import { RadioGroup, RadioGroupItem } from '../../components/ui/radio-group';

export const PACKAGE_OPTIONS = [
  { id: 'incorporate', nameKey: 'wizard.packageNames.incorporate', descKey: 'wizard.packageDescs.incorporate' },
  { id: 'full-launch', nameKey: 'wizard.packageNames.fullLaunch', descKey: 'wizard.packageDescs.fullLaunch' },
  { id: 'corporate-compliance', nameKey: 'wizard.packageNames.corporateCompliance', descKey: 'wizard.packageDescs.corporateCompliance' },
  { id: 'special-project-structuring', nameKey: 'wizard.packageNames.specialProject', descKey: 'wizard.packageDescs.specialProject' },
];

export const Step0Package = ({ formData, updateFormData, errFor, tr }) => (
  <div className="space-y-6">
    <h2 className="text-2xl font-bold text-gray-900 mb-6">{tr('wizard.step0.title')}</h2>

    <div>
      <Label className="text-base font-semibold mb-3 block">{tr('wizard.step0.knowsQuestion')}</Label>
      <RadioGroup
        value={formData.knowsPackage}
        onValueChange={(value) => updateFormData('knowsPackage', value)}
      >
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="yes" id="knows-yes" data-testid="knows-package-yes" />
          <Label htmlFor="knows-yes" className="font-normal cursor-pointer">{tr('wizard.common.yes')}</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="no" id="knows-no" data-testid="knows-package-no" />
          <Label htmlFor="knows-no" className="font-normal cursor-pointer">{tr('wizard.common.no')}</Label>
        </div>
      </RadioGroup>
      {errFor('knowsPackage')}
    </div>

    {formData.knowsPackage === 'yes' && (
      <div data-testid="package-picker">
        <Label className="text-base font-semibold mb-3 block">{tr('wizard.step0.selectPackage')}</Label>
        <div className="space-y-3">
          {PACKAGE_OPTIONS.map((pkg) => {
            const isSelected = formData.selectedPackage === pkg.id;
            return (
              <button
                type="button"
                key={pkg.id}
                onClick={() => updateFormData('selectedPackage', pkg.id)}
                data-testid={`pkg-option-${pkg.id}`}
                className={`w-full text-left p-4 rounded-lg border transition-colors ${
                  isSelected
                    ? 'border-blue-900 bg-blue-50'
                    : 'border-gray-200 bg-white hover:border-blue-900'
                }`}
              >
                <div className="flex items-center gap-3">
                  <div
                    className={`w-4 h-4 rounded-full border-2 flex-shrink-0 ${
                      isSelected ? 'border-blue-900 bg-blue-900' : 'border-gray-300'
                    }`}
                  >
                    {isSelected && <div className="w-2 h-2 bg-white rounded-full m-auto mt-[3px]" />}
                  </div>
                  <div className="flex-1">
                    <p className="font-semibold text-gray-900">{tr(pkg.nameKey)}</p>
                    <p className="text-sm text-gray-600 mt-1">{tr(pkg.descKey)}</p>
                  </div>
                </div>
              </button>
            );
          })}
        </div>
        {errFor('selectedPackage')}
      </div>
    )}
  </div>
);
